import { IConnectedPage } from '../../../../types/api/connectedPages/IConnectedPage';
import { useSearchParams } from 'react-router';
import { useEffect } from 'react';
import { isNullOrUndefined } from '../../../../lib/typeGuards';

function getPagesToDepth(connectedPages: IConnectedPage[], depth = 1): IConnectedPage[] {
  return depth <= 1
    ? []
    : [
        ...connectedPages,
        ...getPagesToDepth(
          connectedPages.flatMap(page => page.childPages || []),
          depth - 1,
        ),
      ];
}

export function useSetInitialOpenPages(connectedPages: IConnectedPage[], initialVisibleDepth: number) {
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    const initialOpenPages = getPagesToDepth(connectedPages, initialVisibleDepth)
      .filter(page => (page.childPages || []).length > 0) // ignore pages that have no children
      .map(page => ['pages', page.pageId]);

    if (initialOpenPages.length > 0) {
      setSearchParams((prevSearchParams) => {
        prevSearchParams.delete('pages');

        return new URLSearchParams([...prevSearchParams, ...initialOpenPages]);
      });
    }
  }, []);

  if (isNullOrUndefined(connectedPages) || connectedPages.length === 0) {
    return null;
  }
}
